export class Esteira {
    idStatus: number;
    nmStatus: string;
}